import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useLang } from "@/context/LanguageContext";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-navy text-white/80 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo variant="light" />
          <p className="mt-5 text-sm leading-relaxed text-white/60">{t("footer.tagline")}</p>
        </div>
        <div>
          <h4 className="font-serif text-lg text-gold mb-4">{t("footer.services")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/acheter" className="hover:text-gold transition-colors">{t("footer.s_buy")}</Link></li>
            <li><Link to="/louer" className="hover:text-gold transition-colors">{t("footer.s_rent")}</Link></li>
            <li><Link to="/investir" className="hover:text-gold transition-colors">{t("footer.s_invest")}</Link></li>
            <li><Link to="/gestion" className="hover:text-gold transition-colors">{t("footer.s_manage")}</Link></li>
            <li><Link to="/conciergerie" className="hover:text-gold transition-colors">{t("footer.s_concierge")}</Link></li>
            <li><Link to="/location-courte-duree" className="hover:text-gold transition-colors">{t("footer.s_shortstay")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-gold mb-4">{t("footer.company")}</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/a-propos" className="hover:text-gold transition-colors">{t("footer.c_about")}</Link></li>
            <li><Link to="/nos-projets" className="hover:text-gold transition-colors">{t("footer.c_projects")}</Link></li>
            <li><Link to="/diaspora" className="hover:text-gold transition-colors">{t("footer.c_diaspora")}</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors">{t("footer.c_blog")}</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">{t("footer.c_contact")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-gold mb-4">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold" /> +228 73 37 95 46</li>
            <li className="flex items-center gap-2"><MessageCircle className="h-4 w-4 text-gold" /> WhatsApp +228 73 37 95 46</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold" /> contact@immomaxe.com</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-gold mt-0.5" /> Lomé, Adidogomé Yokoè, Togo</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} IMMOMAXE. {t("footer.rights")}</span>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/politique-confidentialite" className="hover:text-gold transition-colors" data-testid="footer-privacy">{t("footer.privacy")}</Link>
            <Link to="/termes-conditions" className="hover:text-gold transition-colors" data-testid="footer-terms">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
